import React, { ReactElement } from 'react';
import { Strip } from '../../Models/Article';
import GenreBrowse from '../GenreBrowse/GenreBrowse';
import './BrowseGenreListStrip.scss';

interface BrowseGenreListStripProps {
    strip: Strip;
}

export function BrowseGenreListStrip({ strip: { params } }: BrowseGenreListStripProps): ReactElement {
    // @todo define type
    const { title, items } = params as { title: string; items: { content: { id: number; title: string } }[] };
    return (
        <div className='BrowseGenreListStrip'>
            <GenreBrowse title={title} genres={items.map(item => item.content)} />
        </div>
    );
}
